import { axiosInventoryInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import {
  IUser,
  IProvider,
  IDeleteProvider,
  IFetchProviders,
} from '@/services/provider/provider.type';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { IApiResponse } from '../dashboard/dashboard.type';

// Define the User interface representing the structure of the user object returned by the API

export const fetchProviders = ({
  page = 1,
  limit = 10,
  keywords,
  partnerId,
  order,
  orderBy,
  includeInactive,
  inactive,
}: IFetchProviders): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.PROVIDER.GET_ALL_PROVIDER,
    params: {
      page,
      limit,
      order,
      orderBy,
      ...(keywords !== '' ? { keywords } : {}),
      ...(partnerId ? { partnerId } : {}),
      ...(includeInactive ? { includeInactive } : {}),
      ...(inactive ? { inactive } : {}),
    },
  });
};
export const fetchProvider = (id: string): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.PROVIDER.GET_ALL_PROVIDER}/${id}`,
  );
};

export const createProvider = (
  payload: IProvider,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.PROVIDER.CREATE_PROVIDER}`,
    payload,
  );
};

export const updateProvider = (
  id: string,
  payload: IProvider,
): Promise<AxiosResponse<IUser>> => {
  const body = {
    name: payload?.name,
    partnerId: payload?.partnerId,
    vdiVersion: payload?.vdiVersion,
    syncVdi: payload?.syncVdi,
    ...(payload?.profile ? { profile: payload?.profile } : {}),
    ...(payload?.server ? { server: payload?.server } : {}),
    ...(payload?.configs ? { configs: payload?.configs } : {}),
  };
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.PROVIDER.CREATE_PROVIDER}/${id}`,
    { ...body },
  );
};

export const deleteProvider = (
  id: IDeleteProvider,
): Promise<AxiosResponse<IDeleteProvider, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.PROVIDER.CREATE_PROVIDER}/${id}?syncVdi=true`,
  );
};

export const activateProvider = (
  payload: IProvider,
): Promise<AxiosResponse<IProvider, any>> => {
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.PROVIDER.CREATE_PROVIDER}/${payload.providerId}/activate?syncVdi=true`,
  );
};
